/**
 * Query to get all games categories
 * @returns string
 */
export const getGamesCategoriesQuery = () =>
  'query { swishGamesCategoriesCollection(order:sortOrder_ASC){ total items { categoryName icon { url } } }}';

/**
 * Query to get all games by category
 * @param category
 * @param skip number
 * @param limit number
 * @returns string
 */
export const getGamesByCategoryQuery = (category: string, skip = 0, limit = 5) =>
  `query { swishGamesCollection(order: score_DESC, 
    where: {
      AND : {
        provider_in:["Nostra"]
        nostraCategory_in:["${category}"]
      }
    }
    skip: ${skip}, limit: ${limit}) 
    { total items { sys { id } gameName description nostraCategory score rating images players gameVersionCollection 
    { items { description gameLink } } } }}`;

/**
 * Query to get all popular games
 * @param skip number
 * @param limit number
 * @returns string
 */
export const getPopularGamesQuery = (skip = 0, limit = 5) =>
  `query { swishGamesCuratedListCollection(where: { listName: "Nostra Recommended" }, limit: 1) { items { gamesCollection(skip: ${skip}, limit: ${limit}) { total items { sys { id } gameName description nostraCategory score rating images players gameVersionCollection { items { description gameLink } } } } }}}`;

/**
 * Query to get all games for feed
 * @param skip number
 * @param limit number
 * @returns string
 */
export const getGamesFeedQuery = (skip = 0, limit = 10) =>
  `query { swishGamesCollection(order: rating_DESC, where: {provider_in:["Nostra"]}, skip: ${skip}, limit: ${limit}) { total items { sys { id } gameName description nostraCategory score rating images players gameVersionCollection { items { description gameLink } } } }}`;

/**
 * Query to get a game by id
 * @param id string
 * @returns string
 */
export const getGameDetailsQuery = (id: string) =>
  `query { swishGames(id:"${id}") { gameName description nostraCategory score rating images players gameVersionCollection { items { description gameLink } } }}`;

export const getRecentlyPlayedGames = (id: string[]) => {
  const isdsds = JSON.stringify(id);
  return `query { swishGamesCollection(where: {  sys:{ id_in:${isdsds}} }){ total items{  sys{ id} gameName nostraCategory images rating description}}}`;
};
